/* eslint-disable import/no-unresolved */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { withTranslate } from "react-redux-multilingual";

import ButtonComponent from "components/Button";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import {getURI} from "helpers/utils";

const TopNavUser = (props) => {

  const {
    pathArray, history, titleIcon
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // < 600px
  const isTablet = useMediaQuery(theme.breakpoints.down('md')); // < 900px

  const [tab, setTab] = React.useState("");

  const selectedTabInitial = () => {

    let link = pathArray[1];

    switch (link) {
      case "products":
        setTab("products");
        break;
      case "shops":
        setTab("shops");
        break;
      case "":
        setTab("home");
        break;
      default:
        setTab("");
        break;
    }
  }

  React.useEffect(() => {
    selectedTabInitial();
  });

  // Responsive button labels
  const getButtonLabel = (full, short, mobile) => {
    if (isMobile) return mobile;
    if (isTablet) return short;
    return full;
  };

  // Responsive button size
  const buttonSize = isMobile ? "small" : "medium";
  
  // Responsive spacing
  const buttonSpacing = isMobile ? "5px" : "10px";
  
  // Responsive icon size
  const iconSize = isMobile ? 28 : 36;

  return (
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        paddingTop: { xs: '2px', sm: '5px' },
        width: '100%',
        overflow: 'hidden'
      }}>

          {/* Image Icon at the left */}
          <Link to="/">
          <Box
              component="img"
              src={titleIcon}
              alt="Icon"
              sx={{
                  width: iconSize,
                  height: iconSize,
                  marginLeft: { xs: 0.5, sm: 1 },
                  marginRight: { xs: 1, sm: 2 },
                  flexShrink: 0
              }}
          />
          </Link>

          {/* Navigation Buttons */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center',
            gap: buttonSpacing,
            flexWrap: { xs: 'nowrap', sm: 'wrap' }
          }}>
      <Link to={getURI(process.env.REACT_APP_TYPE, "home", "")}>
        <ButtonComponent
            sx={{ 
              p: { xs: 0.5, sm: 1 }, 
              minWidth: 'auto',
              fontSize: { xs: '0.75rem', sm: '0.875rem', md: '0.875rem' }
            }}
            type="primary"
            size={buttonSize}
            name={getButtonLabel("Home", "Home", "Home")}
            variant={tab === "home" ? "contained" : "outlined"}
        />
      </Link>
      <Link to={getURI(process.env.REACT_APP_TYPE, "products", "")}>
        <ButtonComponent
            sx={{ 
              p: { xs: 0.5, sm: 1 }, 
              minWidth: 'auto',
              fontSize: { xs: '0.75rem', sm: '0.875rem', md: '0.875rem' }
            }}
            type="primary"
            size={buttonSize}
            name={getButtonLabel("All Products", "Products", "Products")}
            variant={tab === "products" ? "contained" : "outlined"}
        />
      </Link>
      <Link to={getURI(process.env.REACT_APP_TYPE, "shops", "")}>
        <ButtonComponent
            sx={{ 
              p: { xs: 0.5, sm: 1 }, 
              minWidth: 'auto',
              fontSize: { xs: '0.75rem', sm: '0.875rem', md: '0.875rem' }
            }}
            type="primary"
            size={buttonSize}
            name={getButtonLabel("All Shops", "Shops", "Shops")}
            variant={tab === "shops" ? "contained" : "outlined"}
        />
      </Link>
          </Box>
      </Box>



  );
};

TopNavUser.propTypes = {
};

export default withTranslate(TopNavUser);
